import React from 'react';
import { IMapPoint } from '../../../../models/interfaces/IMapPoint';
import {
	FloatingIndex,
	WaypointContainer,
	WaypointImage,
	WaypointImageContainer,
	WaypointText,
	WaypointTitle,
} from '../waypointStyles';
import { checkImage, checkString } from '../../../componentUtils';
import parse from 'html-react-parser';

type WaypointProps = {
	waypoint: IMapPoint;
	index: number;
};
const GenericWaypoint: React.FC<WaypointProps> = ({ waypoint, index }) => {
	return (
		<WaypointContainer>
			<WaypointImageContainer>
				<WaypointImage src={checkImage(waypoint.poi_image)} />
				<FloatingIndex>{index + 1}</FloatingIndex>
			</WaypointImageContainer>

			<WaypointText>
				<WaypointTitle>{waypoint.title}</WaypointTitle>
				{parse(checkString(waypoint.short_description))}
			</WaypointText>
		</WaypointContainer>
	);
};

export default GenericWaypoint;
